import { constants } from '../constants';

import type { IAuthorArchiveData } from '../../../templates/archive/author/types';

export const useAuthorSchema = (data: IAuthorArchiveData) => {
  const author = data?.wpUser;
  const images = data?.wpUser?.usersAuthor?.profilePhoto?.sourceUrl;
  const link = data?.wpUser?.usersAuthor?.profilePhoto?.link;
  const mediaItemUrl = data?.wpUser?.usersAuthor?.profilePhoto?.mediaItemUrl;
  
  return JSON.stringify({
    '@context': 'https://schema.org/',
    '@type': 'Person',
    name: `${author?.firstName} ${author?.lastName}`,
    url: link ? link.replace('https://klaviyocms.wpengine.com', constants.url) :  constants.url,
    jobTitle: author?.usersAuthor?.jobTitle ? data?.wpUser?.usersAuthor?.jobTitle : '',
    image: (images && mediaItemUrl) ? mediaItemUrl.replace('https://klaviyocms.wpengine.com', constants.url) : '',
    description: author?.description ? author?.description : '',
    memberOf: [{
      '@type': 'Organization',
      name: constants.brand,
      url:  constants.url,
      logo: constants.logo,
    }],
  });
};
